import { BaseDto } from "@models/base/baseDto.model";
import { TipoServicio } from "../tipo-servicios/tipoServicioDto.model";

export class ServicioDto extends BaseDto{
    public tipoServicio: TipoServicio = new TipoServicio;
    public broche: boolean= false;
    public nroBroche: string = ""

}
